if (!customElements.get("video-slide")) {
  class Videoslide extends HTMLElement {
    constructor() {
      super();
      if (window.initLazyScript) {
        window.initLazyScript(this, this.init.bind(this));
      }
    }

    init() {
      this.slideshow = this.querySelector(".scroll-container");
      this.slidewrap = this.querySelector(".video-slide-wrap");
      this.slides = this.querySelectorAll(".video-slide");
      this.slideBtns = this.querySelectorAll(".video-slide-arrow");
      this.slideDots = this.querySelectorAll(".video-slide-dot");
      this.currentIndex = 0;
      this.realLength = this.slides.length;

      // 克隆首尾，形成 [lastClone, ...real, firstClone] 无限循环
      const firstClone = this.slides[0].cloneNode(true);
      const lastClone = this.slides[this.realLength - 1].cloneNode(true);
      firstClone.classList.remove("is-active");
      lastClone.classList.remove("is-active");
      this.slidewrap.insertBefore(lastClone, this.slides[0]);
      this.slidewrap.appendChild(firstClone);

      this.handleNewArrowClick();
      this.handleDotClick();

      this.setActiveSlide(0, "next");
      const firstSlideVideo = this.slides[0].querySelector("video");
      if (firstSlideVideo) {
        firstSlideVideo.play();
      }

      this.handleTouchSlide();
    }

    setActiveSlide(slideIndex, slideDirection, scrollAni) {
      if (slideIndex === this.currentIndex) return;

      // Cancel any prior calls to this that have not completed
      // clearTimeout(this.setActiveSlideTimeoutId);

      // // Clear autoplay timer
      // clearTimeout(this.autoplayTimer);

      // Set data attribute for direction of slide transitions.
      let dir =
        slideDirection || (slideIndex < this.currentIndex ? "prev" : "next");
      this.dataset.direction = dir;

      this.slideDots.forEach((item, index) => {
        if (index === slideIndex) {
          item.classList.add("is-active");
        } else {
          item.classList.remove("is-active");
        }
      });

      this.slideshow.scrollTo({
        left: this.slides[slideIndex].offsetLeft,
        behavior: scrollAni || "smooth",
      });
      // Move new slide into the viewport.

      // Update current slide and trigger transitions.
      this.slides[slideIndex].classList.add("is-active");
      this.slides[this.currentIndex].classList.remove(
        "is-active",
        "transition-out"
      );

      const slideVideo = this.slides[this.currentIndex].querySelector("video");
      const currentSlideVideo = this.slides[slideIndex].querySelector("video");
      if (slideVideo) {
        slideVideo.pause();
      }
      if (currentSlideVideo) {
        currentSlideVideo.play();
      }

      // Reset autoplay slide timer.
      // if (this.autoplayEnabled) this.autoplayStartTime = Date.now();

      this.currentIndex = slideIndex;

      // Autoplay
      // if (this.autoplayEnabled && !this.autoplayPaused) {
      //   this.autoplayTimeLeft = this.autoplaySpeed;
      //   this.autoplayTimer = setTimeout(
      //     this.showNextSlide.bind(this),
      //     this.autoplaySpeed
      //   );
      // }
      // this.setActiveSlideTimeoutId = setTimeout(() => {
      // }, 200);
    }

    handleNewArrowClick() {
      const self = this;
      this.slideBtns.forEach((item) => {
        item.addEventListener("click", () => {
          if (item.name === "prev") {
            self.showPrevSlide();
          } else if (item.name === "next") {
            self.showNextSlide();
          }
        });
      });
    }

    showNextSlide() {
      let index = this.currentIndex + 1;
      if (index === this.slides.length) index = 0;
      this.setActiveSlide(index, "next");
    }

    showPrevSlide() {
      let index = this.currentIndex - 1;
      if (index < 0) index = this.slides.length - 1;
      this.setActiveSlide(index, "prev");
    }

    handleDotClick() {
      const self = this;
      this.slideDots.forEach((item, index) => {
        item.addEventListener("click", () => {
          self.setActiveSlide(index);
        });
      });
    }

    slideWidth() {
      return this.slides[0].getBoundingClientRect().width + 12; // 含gap(mb)
    }

    handleTouchSlide() {
      // 滑动结束后 snap 到最近 slide
      const self = this;
      let scrollTimeout;
      this.slideshow.addEventListener("scroll", () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          // 滑到第一个
          let idx =
            Math.round(self.slideshow.scrollLeft / self.slideWidth()) - 1;
          if (idx < 0) idx = this.realLength - 1;
          if (idx >= this.realLength) idx = 0;
          // this.currentIndex = idx;
          self.setActiveSlide(idx, undefined, "instant");

          // 滑到最后一个
          if (
            self.slideshow.scrollLeft + self.slideshow.offsetWidth + 1 >=
            self.slideshow.scrollWidth
          ) {
            self.setActiveSlide(0, undefined, "instant");
          }
        }, 100);
      });
    }
  }

  customElements.define("video-slide", Videoslide);
}
